import { LazyLoadingSpinner } from "@/components/LazyLoadingSpinner";
import TeamsConfig from "@/pages/teams/TeamsConfig";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/config")({
  component: TeamsConfig,
  pendingComponent: () => <LazyLoadingSpinner />,
});
